import React from 'react';
import { Chip } from '@mui/material';
import { CheckCircle, Schedule, Cancel } from '@mui/icons-material';

const StatusIndicator = ({ status, size = 'medium' }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'COMPLETED':
        return '#4CAF50';
      case 'PENDING':
        return '#FF9800';
      case 'CANCELLED':
        return '#F44336';
      default:
        return '#9E9E9E';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'COMPLETED':
        return <CheckCircle />;
      case 'PENDING':
        return <Schedule />;
      case 'CANCELLED':
        return <Cancel />;
      default:
        return <Schedule />;
    }
  };

  return (
    <Chip
      icon={getStatusIcon(status)}
      label={status}
      size={size}
      sx={{
        backgroundColor: getStatusColor(status) + '20',
        color: getStatusColor(status),
        fontWeight: 500,
        '& .MuiChip-icon': {
          color: getStatusColor(status),
        },
      }}
    />
  );
};

export default StatusIndicator;
